import { render, staticRenderFns } from "./TermTag.vue?vue&type=template&id=0db35914"
import script from "./TermTag.vue?vue&type=script&lang=js"
export * from "./TermTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db35914')) {
      api.createRecord('0db35914', component.options)
    } else {
      api.reload('0db35914', component.options)
    }
    module.hot.accept("./TermTag.vue?vue&type=template&id=0db35914", function () {
      api.rerender('0db35914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/TermTag.vue"
export default component.exports